import { render, staticRenderFns } from "./DashTypesDialog.vue?vue&type=template&id=1bc69025"
import script from "./DashTypesDialog.vue?vue&type=script&lang=js"
export * from "./DashTypesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports